import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetopandharpur() {



const cardData =
{
  keyword: 'Pune to Pandharpur Bus on Rent',
  heading: 'Sanavi Travels: Pune to Pandharpur Bus on Rent',
  headingDescription: 'Sanavi Travels offers highly reliable, comfortable, and well-organized Pune to Pandharpur Bus on Rent services, specially designed for devotees, Warkari groups, families, senior citizens, corporate groups, and large pilgrimage tours visiting the holy town of Pandharpur. Pandharpur is one of Maharashtra’s most sacred spiritual destinations, renowned for the Vitthal–Rukmini Temple and the grand Wari pilgrimage, attracting lakhs of devotees throughout the year from Pune and surrounding regions. Due to long-distance highway travel, group coordination, and devotional schedules, safe and well-managed bus transportation is essential.',

  top: 'Spiritual & Travel Experiences on Pune to Pandharpur Route',

  "topPlaces": [
    {
      "title": "Vitthal Rukmini Temple Darshan",
      "description": "The Vitthal Rukmini Temple is the heart of Pandharpur and a major pilgrimage site for devotees of Lord Vitthal. Hiring a bus from Pune to Pandharpur allows large groups to travel together comfortably, arrive on time for darshan slots, and avoid the stress of multiple vehicles or public transport. Group bus travel ensures discipline, unity, and a calm devotional atmosphere."
    },
    {
      "title": "Wari & Ekadashi Pilgrimage Travel",
      "description": "Pandharpur Wari and Ekadashi events attract massive pilgrim crowds. Bus on rent from Pune helps Warkari groups and devotees travel safely, manage schedules efficiently, and reduce fatigue during long spiritual journeys."
    },
    {
      "title": "Family Pilgrimage Trips",
      "description": "Families traveling with children and senior citizens prefer bus rental due to better seating comfort, safe driving, and ease of group management throughout the pilgrimage."
    },
    {
      "title": "Senior Citizen Darshan Tours",
      "description": "Senior devotees benefit from bus travel with comfortable seating, smooth rides, and experienced drivers who understand the importance of gentle driving and timely breaks."
    },
    {
      "title": "Group & Bhajan Mandal Travel",
      "description": "Bhajan mandals, religious trusts, and community groups rely on bus rental services to travel together, sing bhajans, and maintain group unity throughout the journey."
    },
    {
      "title": "Overnight Pandharpur Trips",
      "description": "Many devotees plan overnight stays for early morning darshan and aarti. Bus rental supports flexible schedules, night travel safety, and comfortable rest during transit."
    },
    {
      "title": "Corporate Spiritual Tours",
      "description": "Organizations and companies often arrange spiritual trips to Pandharpur for employees. Bus rental ensures professional travel management and punctual coordination."
    },
    {
      "title": "Long Highway Travel Comfort",
      "description": "The Pune to Pandharpur route involves long highway travel. Well-maintained buses with good suspension ensure reduced fatigue and smooth rides for passengers."
    },
    {
      "title": "Single Vehicle Group Coordination",
      "description": "Traveling in one bus avoids coordination issues, convoy risks, and parking challenges near the temple area."
    },
    {
      "title": "Peaceful & Devotional Journey",
      "description": "Professional drivers handle traffic and navigation, allowing devotees to focus on prayers, bhajans, and spiritual preparation."
    }
  ],

  "services": [
    {
      "name": "Pune to Pandharpur Bus on Rent",
      "description": "Sanavi Travels provides complete bus rental solutions from Pune to Pandharpur for pilgrimage groups, families, Warkari yatras, corporate spiritual tours, and wedding-related religious travel. Our service includes clean buses, trained drivers, route planning, flexible pickup points, and reliable scheduling. The focus is on safety, comfort, and spiritual peace, ensuring devotees reach Pandharpur relaxed and on time."
    },
    {
      "name": "AC Bus Pune to Pandharpur",
      "description": "AC buses offer cool and comfortable travel for long-distance Pandharpur trips, especially suitable during summer and peak pilgrimage seasons."
    },
    {
      "name": "Non AC Bus Rental Pune to Pandharpur",
      "description": "Non AC bus rental provides an economical option for large devotional groups seeking budget-friendly travel without compromising safety."
    },
    {
      "name": "Luxury Bus Pune to Pandharpur",
      "description": "Luxury buses feature premium interiors, pushback seating, and enhanced comfort, ideal for corporate and premium pilgrimage groups."
    },
    {
      "name": "Mini Bus Hire Pune to Pandharpur",
      "description": "Mini buses are suitable for small families and compact groups planning a comfortable and flexible pilgrimage."
    },
    {
      "name": "32 Seater Bus Pune to Pandharpur",
      "description": "32 seater buses are ideal for medium-sized groups, offering balanced seating capacity and comfort for long journeys."
    },
    {
      "name": "35 Seater Bus Hire Pune to Pandharpur",
      "description": "35 seater buses accommodate large groups traveling together for darshan, bhajan tours, and religious events."
    },
    {
      "name": "Bus for Family Trip Pune to Pandharpur",
      "description": "Family-focused bus services ensure safe and smooth travel for all age groups, including children and elders."
    },
    {
      "name": "Bus for Corporate Trip Pune to Pandharpur",
      "description": "Corporate bus services support organized spiritual outings with professional travel coordination."
    },
    {
      "name": "Bus for Group Travel Pune to Pandharpur",
      "description": "Group travel buses ensure disciplined, coordinated, and comfortable travel for large devotional groups."
    },
    {
      "name": "Affordable Bus Rental Pune to Pandharpur",
      "description": "Affordable bus rental packages help manage pilgrimage travel budgets while maintaining reliability and safety."
    },
    {
      "name": "Best Bus Service Pune to Pandharpur",
      "description": "Sanavi Travels is trusted as one of the best bus services for Pune to Pandharpur pilgrimage travel."
    },
    {
      "name": "Bus with Driver Pune to Pandharpur",
      "description": "All buses include experienced drivers familiar with Pandharpur routes, temple parking, and pilgrimage traffic."
    },
    {
      "name": "Bus for Wedding Pune to Pandharpur",
      "description": "Wedding-related temple visits to Pandharpur are managed smoothly with comfortable group bus travel."
    },
    {
      "name": "Bus for Outstation Pune to Pandharpur",
      "description": "Outstation bus rentals ensure comfortable long-distance travel with planned breaks and safe driving."
    }
  ],

  "tableData": [
    ["Pune to Pandharpur Bus", "Pilgrimage Travel"],
    ["AC Bus", "Non AC Bus"],
    ["32 Seater Bus", "35 Seater Bus"],
    ["Luxury Bus", "Mini Bus"],
    ["Family Trip", "Group Travel"]
  ],

  "whychoose": [
    { "WhyChooseheading": "Experienced Pilgrimage Drivers", "WhyChoosedescription": "Drivers are familiar with Pandharpur routes and darshan schedules." },
    { "WhyChooseheading": "Comfortable Long-Distance Travel", "WhyChoosedescription": "Spacious seating and smooth ride quality." },
    { "WhyChooseheading": "Safe & Reliable Service", "WhyChoosedescription": "Regular vehicle checks and disciplined driving." },
    { "WhyChooseheading": "Flexible Travel Plans", "WhyChoosedescription": "One-day and overnight trips supported." },
    { "WhyChooseheading": "Multiple Bus Options", "WhyChoosedescription": "Mini, standard, and luxury buses available." },
    { "WhyChooseheading": "Transparent Pricing", "WhyChoosedescription": "No hidden charges." },
    { "WhyChooseheading": "Group-Friendly Travel", "WhyChoosedescription": "Entire group travels together comfortably." },
    { "WhyChooseheading": "Trusted Pilgrimage Partner", "WhyChoosedescription": "Sanavi Travels is trusted for Pandharpur travel." }
  ]
};

const faqData = [
  { question: 'Do you provide buses from Pune to Pandharpur?', answer: 'Yes, Sanavi Travels provides bus rental services from Pune to Pandharpur.' },
  { question: 'Are AC buses available?', answer: 'Yes, both AC and Non AC buses are available.' },
  { question: 'Is the service suitable for senior citizens?', answer: 'Yes, buses are comfortable and safe for elderly devotees.' },
  { question: 'Can we plan an overnight trip?', answer: 'Yes, one-day and overnight Pandharpur trips are supported.' },
  { question: 'Do you provide buses for Wari pilgrimage?', answer: 'Yes, we arrange buses for Wari and Ekadashi pilgrimages.' },
  { question: 'Is driver included in the booking?', answer: 'Yes, all bus rentals include experienced drivers.' },
  { question: 'What seating options are available?', answer: 'Mini bus, 32 seater, and 35 seater buses are available.' },
  { question: 'Are vehicles cleaned and maintained?', answer: 'Yes, all buses are regularly cleaned and serviced.' },
  { question: 'Can pickup points be customized?', answer: 'Yes, pickup locations can be customized as per group needs.' },
  { question: 'Is this an outstation bus service?', answer: 'Yes, Pune to Pandharpur is an outstation bus rental service.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Dattatray Jadhav',
    feedback: 'Very comfortable bus journey from Pune to Pandharpur. Safe driving and good coordination.',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Sunita Pawar',
    feedback: 'Best bus service for Pandharpur darshan. Highly reliable and peaceful journey.',
    rating: 5
  }
];



































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];














  return (
    <div>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/267.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetopandharpur;